import {
  SET_EXCEL_FILE_DATA,
  SET_EXCEL_FILES,
  SET_KPI_TAGS,
  SET_ORGANIZATIONAL_TAGS,
  SET_SELECTED_KPI,
  SET_DATAHUB_DATASET,
  SET_DATASET_KPI_YEAR,
  SET_DATAHUB_DATASET_KPI_DATA,
  SET_DATAHUB_TAB,
  SET_FRAMEWORK_DISCLOSURES,
  SET_DATAHUB_FRAMEWORKS,
  SET_KPI_GROUPS_FOR_DATASETS,
  SET_KPI_GROUPS_FOR_FREQUENCY,
  SET_DATAHUB_KPI_GROUP_FILTER,
  // RESET_COLUMN_VISIBILITY,
  SET_COLUMN_VISIBILITY,
  UPDATE_COLUMN_VISIBILITY,
  RESET_COLUMN_VISIBILITY,
  SET_COLUMN_ORDER,
  UPDATE_COLUMN_ORDER,
  SET_DATAHUB_ITEMS,
  UPDATE_DATAHUB_ITEM,
  REORDER_DATAHUB_ITEMS,
  BATCH_UPDATE_DATAHUB_ITEMS,
  SET_DATAHUB_DATASET_KPI_DATA_FOR_APPROVAL_FLOW,
  SET_FRAMEWORK_DRAWER_DATA,
  SET_FRAMEWORK_DRAWER_OPEN,
} from "constants/datahub/datasetConst";

const initial_state = {
  selectedKPI: null,
  organizationalTags: [],
  kpiTags: [],
  excelFiles: [],
  excelFileData: null,
  dataSetTable: [],
  dataSetKPIYear: null,
  dataSetKPIData: null,
  dataSetKPIDataForApprovalFlow: [],
  kpiGroupsForDataSets: [],
  frequency: [],
  kpiGroupFilterData: [],

  dataHubTab: 0,

  frameworkDisclosures: [],
  datahubFrameworks: [],
  frameworkDrawerData: null,
  isFrameworkDrawerOpen: false,

  // Column visibility state
  columnVisibility: {
    kpiMaster: {},
    kpiGroup: {},
  },

  // Column order state
  columnOrder: {
    kpiMaster: [],
    kpiGroup: [],
  },

  dataHubItems: [],
  dataLinakageItems: [],
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case "RESET_STATE":
      return (state = {
        ...state,
        ...initial_state,
      });
    case SET_SELECTED_KPI:
      return (state = {
        ...state,
        selectedKPI: action.payload,
      });

    case SET_ORGANIZATIONAL_TAGS:
      return (state = {
        ...state,
        organizationalTags: action.payload,
      });

    case SET_KPI_TAGS:
      return (state = {
        ...state,
        kpiTags: action.payload,
      });

    case SET_EXCEL_FILES:
      return (state = {
        ...state,
        excelFiles: action.payload,
      });

    case SET_EXCEL_FILE_DATA:
      return (state = {
        ...state,
        excelFileData: action.payload,
      });
    case SET_DATAHUB_DATASET:
      return (state = {
        ...state,
        dataSetTable: action.payload,
      });

    case SET_DATASET_KPI_YEAR:
      return (state = {
        ...state,
        dataSetKPIYear: action.payload,
      });

    case SET_DATAHUB_DATASET_KPI_DATA:
      return (state = {
        ...state,
        dataSetKPIData: action.payload,
      });
    case SET_DATAHUB_DATASET_KPI_DATA_FOR_APPROVAL_FLOW:
      return (state = {
        ...state,
        dataSetKPIDataForApprovalFlow: action.payload,
      });

    case SET_DATAHUB_TAB:
      return (state = {
        ...state,
        dataHubTab: action.payload,
      });

    case SET_FRAMEWORK_DISCLOSURES:
      return (state = {
        ...state,
        frameworkDisclosures: action.payload,
      });

    case SET_DATAHUB_FRAMEWORKS:
      return (state = {
        ...state,
        datahubFrameworks: action.payload,
      });

    case SET_FRAMEWORK_DRAWER_DATA:
      return {
        ...state,
        frameworkDrawerData: action.payload,
      };

    case SET_FRAMEWORK_DRAWER_OPEN:
      return {
        ...state,
        isFrameworkDrawerOpen: action.payload,
      };

    case SET_KPI_GROUPS_FOR_DATASETS:
      return (state = {
        ...state,
        kpiGroupsForDataSets: action.payload,
      });
    case SET_KPI_GROUPS_FOR_FREQUENCY:
      return (state = {
        ...state,
        frequency: action.payload,
      });
    case SET_DATAHUB_KPI_GROUP_FILTER:
      return (state = {
        ...state,
        kpiGroupFilterData: action.payload,
      });

    // Column visibility cases
    case SET_COLUMN_VISIBILITY:
      return {
        ...state,
        columnVisibility: {
          ...state.columnVisibility,
          [action.payload.context]: action.payload.columns,
        },
      };

    case UPDATE_COLUMN_VISIBILITY:
      return {
        ...state,
        columnVisibility: {
          ...state.columnVisibility,
          [action.payload.context]: {
            ...state.columnVisibility[action.payload.context],
            [action.payload.columnId]: action.payload.isHidden,
          },
        },
      };

    case RESET_COLUMN_VISIBILITY:
      return {
        ...state,
        columnVisibility: {
          ...state.columnVisibility,
          [action.payload.context]: {},
        },
      };

    case SET_COLUMN_ORDER:
      return {
        ...state,
        columnOrder: {
          ...state.columnOrder,
          [action.payload.context]: action.payload.columnOrder,
        },
      };

    case UPDATE_COLUMN_ORDER:
      return {
        ...state,
        columnOrder: {
          ...state.columnOrder,
          [action.payload.context]: action.payload.newOrder,
        },
      };

    case SET_DATAHUB_ITEMS:
      return {
        ...state,
        dataHubItems: action.payload,
      };

    case UPDATE_DATAHUB_ITEM:
      return {
        ...state,
        dataHubItems: state.dataHubItems.map((item) =>
          item.id === action.payload.id
            ? { ...item, ...action.payload.updates }
            : item
        ),
      };

    case REORDER_DATAHUB_ITEMS:
      return {
        ...state,
        dataHubItems: action.payload,
      };

    case BATCH_UPDATE_DATAHUB_ITEMS:
      return {
        ...state,
        dataHubItems: state.dataHubItems.map((item) => ({
          ...item,
          ...action.payload,
        })),
      };

    case "SET_DATAHUB_COLUMNS":
      return {
        ...state,
        dataLinakageItems: action.payload,
      };

    case "UPDATE_DATAHUB_COLUMN":
      return {
        ...state,
        dataLinakageItems: state.dataLinakageItems.map((col) =>
          col.id === action.payload.id
            ? { ...col, ...action.payload.updates }
            : col
        ),
      };

    default:
      return state;
  }
}
